import React from "react";
import { Paginator } from "primereact/paginator";
import { VesselFilter } from "./filters/VesselFilter";
import { MonthFilter } from "./filters/MonthFilter";
import { YearFilter } from "./filters/YearFilter";
import { ApplyFilter } from "./filters/ApplyFilter";

const OffhireReportsFilters = ({
  pageFirst,
  pageRows,
  totalReports,
  onPageChange,
  filterByVessel,
  filterByMonth,
  filterByYear,
  onFilterChange,
  onApply,
}) => {
  return (
    <>
      <div className="bg-white">
        <Paginator
          first={pageFirst}
          rows={pageRows}
          totalRecords={totalReports}
          rowsPerPageOptions={[10, 20, 30]}
          onPageChange={onPageChange}
        ></Paginator>
      </div>
      {/* <div>
        <ReportStatusFilter defaultValue={filterByReportStatus} onChange={onFilterChange} />
      </div> */}
      <div>
        <VesselFilter defaultValue={filterByVessel} onChange={onFilterChange} />
      </div>
      <div>
        <MonthFilter defaultValue={filterByMonth} onChange={onFilterChange} />
      </div>
      <div>
        <YearFilter defaultValue={filterByYear} onChange={onFilterChange} />
      </div>
      <div>
        <ApplyFilter onFilter={onApply} />
      </div>
    </>
  );
};

export default OffhireReportsFilters;
